

export enum ButtonThemes {
    Primary = 'btn-primary',
    Secondary = 'btn-secondary',
    Outline = 'btn-outline',
    Pill = 'btn-pill',
    PillCheckmark = 'btn-pill-checkmark',
    PillCheckmarkActive = 'btn-pill-checkmark active',
}